import ApolloClient from "apollo-boost";
import _ from "lodash";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

const isProducction = process.env.NODE_ENV === "production";
const uri = isProducction ? "https://tags.desigualdadessalud.org/prod/graphql" : "http://localhost:5000/graphql";

const client = new ApolloClient({
  uri
});

const LOAD_TAGS = gql`
  query {
    tags {
      id
      name
    }
  }
`;

const LOAD_TAGS_VALUES = gql`
  query ($filter:AvailableStatsCountQuery!){
    tags{
      id
      name
      values {
        value
        resourcesCount
        availableStatsCount(filter:$filter)
      }
    }
  }
`;

const TAG_VALUES_METADATA = gql`
  query($context: TagValueContextInput!) {
    tagValuesByContext(context: $context) {
      tag {
        id
        name
      }
      value
      resourcesCount
    }
  }
`;

const CREATE_TAG_VALUE = gql`
  mutation($value: TagValueInput!) {
    createTagValue(value: $value) {
      tag {
        id
        name
      }
      value
      resourcesCount
    }
  }
`;

const GET_RESOURCE_TAG_VALUES = gql`
  query($resource: ID!) {
    tagValuesByResource(resource: $resource) {
      tag {
        id
        name
      }
      value
    }
  }
`;

const DELETE_TAG_VALUE = gql`
  mutation($value: TagValueInput!) {
    deleteTagValue(value: $value)
  }
`;

const DELETE_ONE_TAG_VALUE = gql`
  mutation($value: TagValueResource!) {
    deleteTagValueByResource(value: $value)
  }
`;

export function useTagsWithValues({indicator, typing, years, stratifier}) {
  return useQuery(LOAD_TAGS_VALUES, {
    variables : {filter : {
      indicator,
      typing,
      years,
      stratifier
    }},
    client,
  });
}

export function useResourceTagValues({ resource }) {
  const { loading, error, data } = useQuery(GET_RESOURCE_TAG_VALUES, {
    variables: {
      resource
    },
    client,
    fetchPolicy:"cache-and-network"
  });

  return {
    isSafe: !loading && !error,
    data: _.get(data, "tagValuesByResource", []),
    loading
  };
}

export function useDeleteResourceTagValue({ resource, tag, value, onCompleted }) {
  return useMutation(DELETE_ONE_TAG_VALUE, {
    client,
    variables: {
      value: {
        resource,
        tag,
        value
      }
    },
    refetchQueries: [
      {
        query: GET_RESOURCE_TAG_VALUES,
        variables: {
          resource
        }
      }
    ],
    awaitRefetchQueries: true,
    onCompleted
  });
}

export function useTags() {
  const { loading, error, data } = useQuery(LOAD_TAGS, { client, fetchPolicy:"cache-and-network" });

  return {
    isSafe: !loading && !error,
    data: _.get(data, "tags", []),
    loading
  };
}

export function useTagValues(contextType, contextId) {
  const { loading, error, data } = useQuery(TAG_VALUES_METADATA, {
    client,
    variables: {
      context: {
        id: contextId,
        type: contextType
      }
    },
    fetchPolicy:"cache-and-network"
  });

  return {
    isSafe: !loading && !error,
    data: _.get(data, "tagValuesByContext", []),
    loading
  };
}

export function useSaveTagValue(tag, value, contextId, contextType, { onCompleted = _.noop }) {
  const isResource =  contextType === "RESOURCE" ;
  const resourceQueries = isResource ? [{
    query: GET_RESOURCE_TAG_VALUES,
    variables: {
      resource : contextId
    }
  }]: [];
  const contextQueries = !isResource ? [{
    query: TAG_VALUES_METADATA,
    variables: {
      context: {
        id: contextId,
        type: contextType
      }
    },
  }] : [];
  return useMutation(CREATE_TAG_VALUE, {
    client,
    refetchQueries: isResource ? resourceQueries : contextQueries,
    variables: {
      value: {
        tag,
        value,
        context: {
          id: contextId,
          type: contextType
        }
      }
    },
    onCompleted
  });
}

export function useDeleteTagValue(tag, value, contextId, contextType, { onCompleted = _.noop }) {
  return useMutation(DELETE_TAG_VALUE, {
    client,
    refetchQueries: [
      {
        query: TAG_VALUES_METADATA,
        variables: {
          context: {
            id: contextId,
            type: contextType
          }
        }
      },
    ],
    variables: {
      value: {
        tag,
        value,
        context: {
          id: contextId,
          type: contextType
        }
      }
    },
    awaitRefetchQueries: true,
    onCompleted
  });
}



// WEBPACK FOOTER //
// ./src/components/tags-manager/data.js